import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'best-performing-exposure-placeholder',
  templateUrl: './best-performing-exposure-placeholder.component.html',
  styleUrls: ['./best-performing-exposure-placeholder.component.scss']
})
export class BestPerformingExposurePlaceholderComponent implements OnInit {

  public postItems = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  @Input() fallbackTitle: string;
  @Input() fallbackMessage: string;

  constructor(private translate: TranslateService, private userService: UserService) { }

  ngOnInit() {
    if (!this.fallbackTitle && this.userService.isFreeUser() && !this.userService.isAdmin) {
      this.fallbackTitle = this.translate.instant('common.invalid_action_by_levels_warning.fallback_title');
    }

    if (!this.fallbackMessage && this.userService.isFreeUser() && !this.userService.isAdmin) {
      this.fallbackMessage = this.translate.instant('common.invalid_action_by_levels_warning.fallback_message');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-exposure-placeholder/best-performing-exposure-placeholder.component.ts